import { render, staticRenderFns } from "./SuccessCreateModal.vue?vue&type=template&id=0187a71b"
import script from "./SuccessCreateModal.vue?vue&type=script&lang=js"
export * from "./SuccessCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports